export default {
  user(state: {[p: string]: any}, payload: {[p: string]: any}): void {
    state.user = payload;
  },
};
